import Filter from './Filter'

export default class MonitoringInno extends Filter {
    filterComponent = import('@/views/components/filters/compoents/MonitoringInnoFilterComponent.vue')

    static ADMISSION_YEAR = 'admission_year'

    static COURSE = 'course'

    static DC_TYPE = 'dc_type'

    static REGION = 'org_region_id'

    static DIRECTION = 'direction_id'

    static ORGANIZATION = 'organization_id'

    static PERIOD = 'period_id'

    static QUARTER = 'quarter_id'

    static REPORT_STATUS = 'report_status'

    static STATUS = 'status'

    static REASON_STATUS = 'reason_status'

    static ADVISOR = 'advisor_id'

    static SCHOLARSHIP_STATUS = 'scholarship_status'

    static ORG_REGION = 'org_region_id'

    fields = {
      [MonitoringInno.ADMISSION_YEAR]: {
        label: 'Admission Year',
      },
      [MonitoringInno.COURSE]: {
        label: 'Course',
      },
      [MonitoringInno.DC_TYPE]: {
        label: 'Dc Type',
      },
      [MonitoringInno.REGION]: {
        label: 'Regions',
      },
      [MonitoringInno.DIRECTION]: {
        label: 'Direction',
      },
      [MonitoringInno.ORGANIZATION]: {
        label: 'Universities',
      },
      [MonitoringInno.PERIOD]: {
        label: 'Reporting year',
      },
      [MonitoringInno.QUARTER]: {
        label: 'Quarter',
      },
      [MonitoringInno.REPORT_STATUS]: {
        label: 'Advisor status',
      },
      [MonitoringInno.STATUS]: {
        label: 'Monitoring report status',
      },
      [MonitoringInno.REASON_STATUS]: {
        label: 'Reason',
      },
      [MonitoringInno.ORG_REGION]: {
        label: 'Region',
      },
      [MonitoringInno.ADVISOR]: {
        label: 'Research Advisor',
      },
      [MonitoringInno.SCHOLARSHIP_STATUS]: {
        label: 'Scholarship Status',
      },
    }
}
